
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/psychology-behind-different-experiences",
      function () {
        return require("private-next-pages/blog/psychology-behind-different-experiences.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/psychology-behind-different-experiences"])
      });
    }
  